import React, { useEffect, useRef } from 'react';

import { Heading, GenericP, GenericDiv } from 'commonStyles';
import * as S from './BusinessDesignStyle';
import { OrangeBorder } from '../../Style';
import { RESOURCE_CONSTANT } from 'AppConstants';
import { trackClickEventSimple } from 'omnitures';

const RightTabList = ({ setIndexClicked, indexClicked, isMobile, businessTabContent = {} }) =>{
	const { heading = '', subHeading = '', content = [] } = businessTabContent;
	const timer = useRef(null);
	useEffect(() => {
		timer.current = setInterval(function() {
			setIndexClicked(((prevInd) => (prevInd + 1) % 3));
		}, RESOURCE_CONSTANT.ANIMATE_INTERVAL);
		return () => {
			if (timer.current) {
				clearInterval(timer.current);
			}
		};
	}, [setIndexClicked]);

	const tabClickHandler = (item, index) => () => {
		setIndexClicked(index);
		trackClickEventSimple(item.trackVal);
		if (timer.current) {
			clearInterval(timer.current);
		}
	};

	return (
		<S.TabWrapper $width={`${isMobile ? '100%' : '48%'}`}>
			<GenericDiv left_M={`${isMobile ? '-16' : ''}`}>
				<OrangeBorder />
			</GenericDiv>
			<Heading
				fontSize={`${isMobile ? '24px' : '40px'}`}
				marBt={`${isMobile ? '8px' : '5px'}`}
				dangerouslySetInnerHTML={{ __html: heading }}
			/>
			<GenericDiv $width={`${isMobile ? '90%' : ''}`}>
				<GenericP
					$width={`${isMobile ? '10%' : ''}`}
					fsize={`${isMobile ? '14px' : '16px'}`}
					bottom_M={`${isMobile ? '16' : '40'}`}>
					{subHeading}
				</GenericP>
			</GenericDiv>
			<S.ListWrapper>
				<S.UserChoice
					isMobile={isMobile}
					translateBy={`${270 * indexClicked}px`}>
					{content.map((item, index) => (
						<S.UserChoiceItem
							id={`userChoiceList${index}`}
							key={index}
							className={`${indexClicked === index ? 'active' : ''} `}
							onClick={tabClickHandler(item, index)}>
							{item.heading}
						</S.UserChoiceItem>
					))}
				</S.UserChoice>
			</S.ListWrapper>
		</S.TabWrapper>
	);
};

export default RightTabList;
